

























import { defineComponent } from 'vue'
import Modal from '~/components/DialogModal.vue';
import LinhaDoc from './_components/linha-doc.vue';
import { Linha, Receita, doc_linha_sevice } from '~/store/docs';

export type DataType = {
    records: Linha[],
    receitas: Receita[]
}

export default defineComponent({
    components: {
        Modal,
        LinhaDoc
    },
    props: {
        codigo: {
            type: String,
            required: true
        }
    },
    data(): DataType {
        return {
            receitas: [],
            records: []
        }
    },
    methods: {
        onClose() {
            this.$router.back()
        },
        setLinhas(linhas: Linha[]) {
            this.records = linhas
        },
        setReceitas(receitas: Receita[]) {
            this.receitas = receitas
        },
        updated(linhas: Linha[]) {            
            this.setLinhas(linhas)
            this.$emit('updated')
        },
        async load() {
            try {
                let resp = await doc_linha_sevice.consulta(Number(this.codigo))
                this.setLinhas(resp.linhas)
                this.setReceitas(resp.inclusao.receitas)
            } catch (error) {
                console.error(error)
            }
        }
    },
    watch: {
        codigo: {
            immediate: true,
            handler() {
                this.load()
            }
        }
    }
})

